import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noComma',
  standalone: true,
})
export class NoCommaPipe implements PipeTransform {
  transform(value: number): string {
    if (value !== undefined && value !== null) {
      return value.toString().replace(/,/g, '');
    } else {
      return '';
    }
  }
}
